// extracted by mini-css-extract-plugin
module.exports = {"radio-label":"questionnaire-radio_radio-label__agOUs","radio-item":"questionnaire-radio_radio-item___YvjS"};